import { useMemo } from "react";
import { useParams } from "react-router-dom";
import classNames from "classnames";

import { CCard, CCardBody } from "@coreui/react";

import { hangHoaApi } from "src/1/apis/hang_hoa.api";
import { history } from "src/App";
import { CButton } from "src/common/components/controls";
import { CActionGroup } from "src/common/components/others";
import { fireDelete } from "src/utils/alert";

import { Goods } from "./Goods";
import { Information } from "./Information";

export const DieuChinhGiaForm = ({ control, onSubmit, isSubmitting, data }) => {
  //#region Data
  const params = useParams();

  const isBlock = useMemo(() => !!params?.id, [params?.id]);
  //#endregion

  //#region Event
  const onClick = (key) => {
    switch (key) {
      case "save":
        return onSubmit();
      default:
        break;
    }
  };

  const onApprove =
    (accept = false) =>
    async () => {
      const allow = await fireDelete({
        title: accept ? "Xác nhận duyệt" : "Từ chối duyệt",
        text: accept
          ? "Đồng ý với yêu cầu điều chỉnh giá này"
          : "Từ chối yêu cầu điều chỉnh giá",
        confirmText: "Ok",
      });
      if (allow) {
        try {
          await hangHoaApi.approveChangePrice(params.id, {
            is_approval: accept,
          });
          noti("success", "Đã lưu thông tin bước duyệt");
          history.push("/menus/change-price/list");
        } catch (error) {
          noti("error", error?.message || "Có lỗi xảy ra");
        }
      }
    };
  //#endregion

  //#region Render
  return (
    <>
      <CCard>
        <CCardBody>
          {params?.id ? (
            <div className="flex flex-row items-center justify-between">
              <div className="text-lg font-medium">
                Trạng thái:&nbsp;
                <span
                  className={classNames(
                    data?.approval_status === "done" && "text-green-500",
                    data?.approval_status === "reject" && "text-red-500",
                  )}
                >
                  {data?.status}
                </span>
              </div>
              {data?.is_approval && (
                <div className="flex flex-row gap-2">
                  <CButton onClick={onApprove(true)}>Duyệt</CButton>
                  <CButton onClick={onApprove()} color="danger">
                    Từ chối
                  </CButton>
                </div>
              )}
            </div>
          ) : (
            <CActionGroup
              onClick={onClick}
              canAdd={false}
              canSave={!isSubmitting}
              hidePrintBtn
            />
          )}

          <Information control={control} isBlock={isBlock} />
        </CCardBody>
      </CCard>

      <Goods control={control} isBlock={isBlock} />
    </>
  );
  //#endregion
};
